import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { MessageType } from '../../types';
import { getErrorText } from '../helpers';

type Params = Pubnub.PublishParameters & { onPublish?: (timetoken: string) => void };
export type Response = { timeToken: string; messageType: MessageType };

export const publishMessage = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/publishMessage',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;

      if (pubnubReducer.pubnub) {
        const result = await pubnubReducer.pubnub.publish({
          channel: data.channel,
          message: data.message,
        });
        const message = JSON.parse(data.message);

        data.onPublish?.(`${result.timetoken}`);

        return { timeToken: `${result.timetoken}`, messageType: message.type };
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
